import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/ImageStrip.module.css';

const ImageStrip = ({ eyebrow, items, ariaLabel, columns }) => {
  const renderCard = item => {
    const content = (
      <>
        <img className={styles.image} src={item.src} alt={item.alt || item.title} loading="lazy" />
        <span className={styles.overlay} aria-hidden="true">
          <span className={styles.overlayTitle}>{item.title}</span>
          {item.subtitle && <span className={styles.overlaySubtitle}>{item.subtitle}</span>}
        </span>
      </>
    );

    if (item.to) {
      return <Link className={styles.card} to={item.to}>{content}</Link>;
    }

    if (item.href) {
      return <a className={styles.card} href={item.href}>{content}</a>;
    }

    return <div className={styles.card}>{content}</div>;
  };

  return (
    <section className={styles.section} aria-label={ariaLabel || eyebrow}>
      <div className={styles.inner}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        <div className={`${styles.grid} ${columns === 7 ? styles.sevenColumns : ''}`}>
          {items.map(item => <React.Fragment key={item.id || item.src}>{renderCard(item)}</React.Fragment>)}
        </div>
      </div>
    </section>
  );
};

ImageStrip.defaultProps = {
  eyebrow: '',
  items: [],
  ariaLabel: 'Image gallery',
  columns: 6,
};

export default ImageStrip;
